import { prop } from 'ramda';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { userSetAttributesAction } from 'js/hooks/user/store/actions';
import {
    useFetchBalance,
    useFetchUserDetails,
    useGetUserUrlTemplates,
    useGetPaymentsConfiguration
} from 'js/hooks/user';

export const useAfterLoginAction = () => {
    const verifyJumio = useVerifyJumio();
    const getUrlTemplates = useGetUserUrlTemplates();
    const fetchUserDetails = useFetchUserDetails();
    const getPaymentsConfiguration = useGetPaymentsConfiguration();
    const fetchBalance = useFetchBalance();

    return useCallback(() => Promise.all([
        fetchUserDetails().then(verifyJumio),
        getUrlTemplates(),
        getPaymentsConfiguration(),
        fetchBalance()
    ]), [
        fetchUserDetails, verifyJumio, getUrlTemplates, fetchBalance,
        getPaymentsConfiguration
    ]);
};

export const useVerifyJumio = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const netVerifyJumioEnabled = useAppSelector(prop('netVerifyJumioEnabled'));
    const { suspended, ageVerificationStatus } = useUserSelector(prop('userDetails'));

    return useCallback(() => {
        const params = new URLSearchParams(location.search);
        const isHideKYC = params.get('hideKYC') === '1';
        const isUserSuspended = suspended === 'true';
        const isJumioAllowed = netVerifyJumioEnabled && ageVerificationStatus === 'inprocess';

        if (isJumioAllowed && !isHideKYC) {
            dispatch(userSetAttributesAction({ suspended: isUserSuspended }));

            dispatcher.dispatch('app:message', { ID: 'userVerify' });

            if (isUserSuspended) {
                dispatcher.dispatch('auth:suspend', true);

                return Promise.reject(false);
            }

            dispatcher.dispatch('auth:suspend', false);
        }

        return true;
    }, [location, suspended, ageVerificationStatus, netVerifyJumioEnabled, dispatch]);
};
